import { Markdown } from '@tiptap/markdown';

import { extensions, markedOptions } from '@eluve/tiptap-extensions';

import CustomKeymap from './custom-keymap';
import { Footnote } from './footnotes';
import { MarkdownPaste } from './markdown-paste';
import { SlashCommandExtension } from './slash-command';

export const defaultExtensions = [
  ...extensions,
  SlashCommandExtension,
  CustomKeymap,
  Footnote,
  MarkdownPaste,
  // `markedOptions` is shared with the compare-time normalizer (normalizeMarkdown)
  // so the editor's serialization and the score/diff canonical form can't drift —
  // see its definition in @eluve/tiptap-extensions. `breaks: true` keeps the
  // model's semantic single newlines (e.g. ENT Objective per-region lines) from
  // collapsing to spaces. Empty-paragraph round-tripping is handled by
  // @tiptap/markdown directly (the v2 EmptyParagraphPreserver is upstreamed in v3).
  // See ENG-4453.
  Markdown.configure({ markedOptions }),
];
